import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=48a923a2&scoped=true"
import script from "./ContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=48a923a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a923a2",
  null
  
)

export default component.exports